import {
  useConsumerIdentityStore,
  type ConsumerIdentityBind,
} from "../store/useConsumerIdentityStore";
import { useSessionStore } from "../store/useSessionStore";
import type { IBindConsumerIdentityResponse } from "../services/api";
import { buildDistinctId, safeIdentify } from "../analytics";

export function applyConsumerIdentityBind(args: {
  clerkSessionId?: string;
  linkId?: string | null;
  bound: IBindConsumerIdentityResponse;
}): void {
  if (args.clerkSessionId && args.linkId) {
    const existing = useConsumerIdentityStore.getState().bind;
    const sameViewer =
      existing?.clerkSessionId === args.clerkSessionId &&
      existing.linkId === args.linkId;
    useConsumerIdentityStore.getState().setBind({
      clerkSessionId: args.clerkSessionId,
      linkId: args.linkId,
      occupancy: args.bound.occupancy,
      isOccupant: args.bound.isOccupant,
      referenceId: args.bound.referenceId,
      payerFirstName:
        args.bound.user.firstName ||
        (sameViewer ? existing?.payerFirstName : undefined),
      novu: args.bound.novu ?? (sameViewer ? existing?.novu : undefined),
    });
  }

  const current = useSessionStore.getState().session.data;
  if (current) {
    useSessionStore.getState().updateSession({
      ...current,
      termsAccepted: args.bound.termsAccepted,
      termsAcceptedAt: args.bound.termsAcceptedAt,
      userData: {
        ...current.userData,
        referenceId: args.bound.referenceId,
      },
      user: {
        ...current.user,
        hasPhoneNumber: args.bound.user.hasPhoneNumber === true,
        country: args.bound.user.country,
      },
    });
  }

  const partnerId = current?.partner?.partnerId;
  if (partnerId && args.bound.referenceId) {
    safeIdentify(buildDistinctId(partnerId, args.bound.referenceId), {
      partner_id: partnerId,
      reference_id: args.bound.referenceId,
    });
  }
}

export function clearConsumerIdentityBind(): void {
  useConsumerIdentityStore.getState().clearBind();
}

export function consumerIdentityCacheMatches(
  bind: ConsumerIdentityBind | null,
  clerkSessionId: string | undefined,
  linkId: string | null | undefined,
): bind is ConsumerIdentityBind {
  return Boolean(
    bind &&
      clerkSessionId &&
      linkId &&
      bind.clerkSessionId === clerkSessionId &&
      bind.linkId === linkId,
  );
}
